import React from "react";
import { Alert, Empty, List, Spin } from "antd";
import UserEffectivePermissions from "./UserEffectivePermissions";

export default function RoleUsers({
  users,
  selectedUser,
  loading,
  error,
  onSelectUser,
  effectiveProps,
}) {
  if (loading) {
    return (
      <div className="rp-centered">
        <Spin />
      </div>
    );
  }

  if (error) {
    return <Alert type="error" message={error} showIcon />;
  }

  return (
    <div className="rp-users">
      <section className="rp-users-list">
        <h6>Usuarios del rol</h6>
        {!users.length ? (
          <Empty description="No hay usuarios asignados" />
        ) : (
          <List
            bordered
            size="small"
            dataSource={users}
            renderItem={(user) => (
              <List.Item
                className={selectedUser?.iduser === user.iduser ? "active" : ""}
                onClick={() => onSelectUser(user)}
              >
                Usuario #{user.iduser}
              </List.Item>
            )}
          />
        )}
      </section>

      <section className="rp-users-detail">
        <UserEffectivePermissions user={selectedUser} {...effectiveProps} />
      </section>
    </div>
  );
}
